<template>
  <div class="container">
    <ts-loading-banner :loading="waiting">
      <ts-table
        :columns="columns"
        :records="resources"
        :rowGroup="{
          field: 'inv_number'
        }"
      >
        <template v-slot="{ record }">
          <td class="ts-whitespace-no-wrap">{{ record.fee_type_name }}</td>
          <td class="ts-whitespace-no-wrap">{{ record.fee_name }}</td>
          <td class="ts-whitespace-no-wrap">
            {{ record.fee_start_date ? record.fee_start_date : null }}
          </td>
          <td class="ts-whitespace-no-wrap">
            {{ record.fee_end_date ? record.fee_end_date : null }}
          </td>
          <td class="text-center">
            {{ record.quantity ? record.quantity : null }}
          </td>
          <td class="text-center">
            {{ record.fee_amount ? roundNum(record.fee_amount) : null }}
          </td>
          <td class="text-center">{{ record.subscription_status }}</td>
        </template>
      </ts-table>
    </ts-loading-banner>
  </div>
</template>
<script>
import { mapActions } from 'vuex'
export default {
  name: 'latestInvoice',
  props: ['isActive', 'studentId', 'acpId'],
  data() {
    return {
      waiting: false,
      resources: []
    }
  },
  computed: {
    roundNum: vm => num => {
      return _.round(num, 2)
    },
    columns() {
      return [
        { name: this.$t('invoice.feeType') },
        { name: this.$t('invoice.feeName') },
        { name: this.$t('invoice.dateFrom') },
        { name: this.$t('invoice.dateTo') },
        { name: this.$t('invoice.qty'), style: 'text-align:center' },
        { name: this.$t('invoice.amount'), style: 'text-align:center' },
        { name: this.$t('invoice.status'), style: 'text-align:center' }
      ]
    }
  },
  methods: {
    ...mapActions('invoice', ['getLatestInvoice']),
    fetchData() {
      this.waiting = true
      this.resources = []
      this.getLatestInvoice(this.studentId)
        .then(response => {
          this.resources = response.data
        })
        .catch(error => {
          this.$toasted.error(error.message)
        })
        .finally(() => {
          this.waiting = false
        })
    }
  },
  watch: {
    studentId: function(id) {
      if (this.isActive == 3) {
        this.fetchData()
      }
    }
  }
}
</script>

<style lang="css" scoped>
.container {
  max-height: 35vh;
  height: 30vh;
  overflow: scroll;
}
.table > thead > tr > th {
  padding: 5px 15px;
}
.table > tbody > tr > td {
  padding-top: 5px !important;
  padding-bottom: 5px !important;
  font-size: 12px !important;
}
</style>
